import { useMutation } from 'react-query';
import { API } from 'api';
import { useDispatch } from 'react-redux';
import { toastPush } from 'modules';
import { useTranslation } from 'react-i18next';

export interface IWithdrawalConsentDownloadData {
  payload: {
    eid: string;
    from?: number;
    to?: number;
  };
}

const getWithdrawalConsentDownload = (data: IWithdrawalConsentDownloadData['payload']) => {
  return API.post()('/api/employee/download/withdrawal/consent', data);
};

export const useWithdrawalConsentDownloadData = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return useMutation(getWithdrawalConsentDownload, {
    onSuccess: () => {
      dispatch(
        toastPush({
          code: 200,
          type: 'success',
          title: 'SUCCESS',
          body: 'toastPush.downloadReportSuccessPleaseCheckMailbox',
        })
      );
    },
  });
};
